import { Home, Compass, Search, Users } from 'lucide-react'
import type { ReactNode } from 'react'
import { crewTabLabel } from './commonStrings'

export type NavTab = {
  to: string
  icon: typeof Home
  label: ReactNode
}

// fbt() / <fbt> calls must run *after* LocaleContext registers fbtee's hooks,
// so navTabs is a function — building the array at module-eval time throws
// "Hooks: 'getFbtResult' is not registered" in chunks that load before main.
export function getNavTabs(): readonly NavTab[] {
  return [
    {
      to: '/',
      icon: Home,
      label: <fbt desc="Nav label for the home tab">Home</fbt>,
    },
    {
      to: '/discover',
      icon: Compass,
      label: <fbt desc="Nav label for the discover tab, which browses festivals and parties">Discover</fbt>,
    },
    {
      to: '/search',
      icon: Search,
      label: <fbt desc="Nav label for the search tab">Search</fbt>,
    },
    {
      to: '/social',
      icon: Users,
      label: crewTabLabel(),
    },
  ]
}
